<template>
  <!--  -->
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-16 shadow-lg items-center">
    <!--  -->
    <div class="bg-white w-fullrounded-lg shadow">
      <!--  -->
      <div class="h-20 py-3 flex items-center border-gray-300 p-6 mt-5">
        <!--  -->
        <div class="flex">
          <!--  -->
          <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()">
            <!--  -->
            <i class="material-icons">chevron_left</i>
            <!--  -->
          </button>
          <!--  -->

          <!--  -->
          <div v-if="!formData._id" class="text-2xl font-bold text-primary-500">
            {{ $t('new_user') }}
          </div>
          <!--  -->

          <!--  -->
          <div v-else class="text-2xl font-bold text-primary-500">
            {{ $t('edit_user') }}
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="relative">
        <!--  -->

        <!--  -->
        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <!--  -->

        <!--  -->
        <div class="bg-white rounded-lg p-6">
          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
            <!--  -->
            <div
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="fullName" class="bg-white text-gray-700 px-1">{{ $t('full_name') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="fullName" autocomplete="false" tabindex="0" type="text" v-model="formData.fullName"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="formData._id"
              class="border-2 border-orange-700 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="phone" class="bg-white text-gray-700 px-1">{{ $t('phone') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="phone" autocomplete="false" tabindex="0" type="text" v-model="formData.phone"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="username" class="bg-white text-gray-700 px-1">{{ $t('username') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="username" autocomplete="false" tabindex="0" type="text" v-model="formData.username"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                  @keydown.space="event => event.preventDefault()" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="email" class="bg-white text-gray-700 px-1">{{ $t('email') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input autocomplete="false" tabindex="0" type="email" :disabled="formData._id" v-model="formData.email"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="formData._id && formData.type == 'Seller'"
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="company" class="bg-white text-gray-700 px-1">{{ $t('store') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input autocomplete="false" tabindex="0" :disabled="company" type="text" v-model="formData.company"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>

            <!--  -->
            <div
              class="border h-10 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="name" class="bg-white text-gray-700 px-1">{{ $t('role') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select label="name" @input="onChangeRole(formData.role)" @search="searchRoles($event, 'hh')"
                  v-model="formData.role" :options="roles"></v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="formData._id && formData.type == 'Seller'"
              class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="rib" class="bg-white text-gray-700 px-1">{{ $t('rib') }} *</label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input autocomplete="false" tabindex="0" type="text" v-model="formData.rib"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              v-if="$f.getAccess(currentUser.role.permissions, 'users', 'create') && formData.type && (formData.type == 'Seller' || formData.type == 'Courier')"
              class="border seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="Countries" class="bg-white text-gray-700 px-1">
                    {{ $t('source') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select
                  :disabled="formData.source && (formData.source == 'STOREINO' || formData.source == 'LEADVERTEX') ? true : false"
                  @input="setSource" v-model="formData.source" :options="sources"></v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="$f.getAccess(currentUser.role.permissions, 'users', 'create')"
              class="border seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="Countries" class="bg-white text-gray-700 px-1">
                    {{ $t('countries') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select label="countryName" @input="setSelectedCountries" v-model="formData.countries"
                  :options="warehouses" multiple>
                  <!--  -->
                  <template slot="option" slot-scope="option">
                    <!--  -->
                    <img class="flag-img" :src="$f.getCountryCode(option.country)" />
                    <!--  -->
                    {{ option.countryName }}
                  </template>
                  <!--  -->
                </v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              v-if="formData.source && ((livreur && selectedRole == livreur) || (formData.type && formData.type == 'Seller' && formData.source == 'CHRONODIALI'))"
              class="border hover:border-orange-500 p-4 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded">
              <!--  -->
              <button @click="isHidden = !isHidden" :class="isHidden ? 'mb-4' : ''"
                class="btn-marketing inline-block btn-marketing btn-primary w-full button_blink">
                <!--  -->
                <div class="flex items-center h-100 justify-center">
                  <!--  -->
                  <span class="">Api key</span>
                  <!--  -->

                  <!--  -->
                  <svg class="fill-current ml-2" viewBox="0 0 24 24" width="18" height="18"
                    xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                    <!--  -->
                    <path
                      d="M16 1c-4.418 0-8 3.582-8 8 0 .585.063 1.155.182 1.704l-8.182 7.296v5h6v-2h2v-2h2l3.066-2.556c.909.359 1.898.556 2.934.556 4.418 0 8-3.582 8-8s-3.582-8-8-8zm-6.362 17l3.244-2.703c.417.164 1.513.703 3.118.703 3.859 0 7-3.14 7-7s-3.141-7-7-7c-3.86 0-7 3.14-7 7 0 .853.139 1.398.283 2.062l-8.283 7.386v3.552h4v-2h2v-2h2.638zm.168-4l-.667-.745-7.139 6.402v1.343l7.806-7zm10.194-7c0-1.104-.896-2-2-2s-2 .896-2 2 .896 2 2 2 2-.896 2-2zm-1 0c0-.552-.448-1-1-1s-1 .448-1 1 .448 1 1 1 1-.448 1-1z" />
                    <!--  -->
                  </svg>
                  <!--  -->
                  <div class="max-h-full max-w-full md:ml-2 ml-2"></div>
                  <!--  -->
                </div>
                <!--  -->
              </button>
              <!--  -->

              <!--  -->
              <span v-if="isHidden">
                <!--  -->
                <template v-for="key in Object.keys(apiShipping)">
                  <!--  -->
                  <div class="mb-4">
                    <!--  -->
                    <label class="block text-grey-700 text-sm mb-2" for="full-name">
                      <!--  -->
                      <div class="flex justify-between">
                        <!--  -->
                        <div>
                          <!--  -->
                          <span>{{ key }}</span>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </label>
                    <!--  -->

                    <!--  -->
                    <span v-if="key == 'color' || key == 'gardien'">
                      <!--  -->
                      <chrome-picker v-model="apiShipping[key]" />
                      <!--  -->
                    </span>
                    <!--  -->

                    <!--  -->
                    <span v-else>
                      <!--  -->
                      <input autofocus="autofocus" v-model="apiShipping[key]" class="marketing-input border-gray-300"
                        placeholder="xxxxxxxxxxxxxxxx"
                        :type="['Password', 'client_id', 'client_secret'].indexOf(key) == -1 ? 'text' : 'password'"
                        :id="key" />
                      <!--  -->
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->
                </template>
                <!--  -->
              </span>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="!formData._id" class="flex items-center justify-between">
              <!--  -->
              <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
              <!--  -->
              <span @click="CreateNewRole"
                class="text-xs text-primary-500 font-bold cursor-pointer uppercase dark:text-primary-400 hover:underline">{{
                  $t('create_new_role') }}
              </span>
              <!--  -->
              <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="w-full" v-if="this.formData.type === 'CallcenterManager'">
            <!--  -->
            <div class="flex w-full space-x-6 h-full overflow-hidden">
              <!--  -->
              <div
                class="border mt-8 w-1/2 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="name" class="bg-white text-gray-700 px-1">
                      <!--  -->
                      Add TeleConsultant
                      <!--  -->
                      <span :class="$colors.required"> *</span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="md:w-full flex flex-col items-center p-1">
                  <!--  -->
                  <div class="w-full">
                    <!--  -->
                    <div class="flex flex-col items-center relative">
                      <!--  -->
                      <div class="w-full">
                        <!--  -->
                        <div class="mt-2 p-1 bg-white flex border border-gray-300 rounded">
                          <!--  -->
                          <div class="flex flex-auto flex-wrap"></div>
                          <!--  -->

                          <!--  -->
                          <input @input="searchTeleConsultants($event)" v-model="searchTextTeleConsultant"
                            placeholder="Search TeleConsultants"
                            class="p-1 px-2 appearance-none outline-none w-full text-gray-800" />
                          <!--  -->

                          <!--  -->
                          <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-300">
                            <!--  -->
                            <button class="cursor-pointer w-6 h-6 text-orange-500 outline-none focus:outline-none">
                              <!--  -->
                              <i class="material-icons">search</i>
                              <!--  -->
                            </button>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div class="bg-white mt-4 mb-2 max-h-select top-100 z-40 w-full rounded overflow-y-auto h-full">
                        <!--  -->
                        <div v-for="(user, index) in agents" :key="index" :value="user._id"
                          class="flex flex-col w-full">
                          <!--  -->
                          <div
                            class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-300 dark:border-dark-1 w-full  rounded-t hover:bg-teal-100">
                            <!--  -->
                            <div class="flex w-full items-center p-2 pl-2 relative hover:border-teal-100">
                              <!--  -->
                              <div class="w-6 flex flex-col items-center">
                                <!--  -->
                                <div class="flex relative w-5 h-5 justify-center items-center m-1 mr-2">
                                  <!--  -->
                                  <i class="material-icons mx-2">account_circle</i>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->

                              <!--  -->
                              <div class="w-full items-center flex">
                                <!--  -->
                                <div class="mx-2 mt-2">
                                  <!--  -->
                                  {{ user.fullName }}
                                  <!--  -->
                                  <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                    <!--  -->
                                    {{ user.email }}
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->

                              <!--  -->
                              <div class="w-6 flex flex-col items-center">
                                <!--  -->
                                <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none"
                                  @click="addItem(index)">
                                  <!--  -->
                                  <i class="material-icons">add</i>
                                  <!--  -->
                                </button>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="border mt-8 w-1/2 h-select hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="name" class="bg-white text-gray-700 px-1">
                      <!--  -->
                      Selected TeleConsultant
                      <!--  -->
                      <span :class="$colors.required"></span>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="md:w-full flex flex-col items-center h-64">
                  <!--  -->
                  <div class="flex items-center justify-center py-2" v-if="formData.teleConsultants.length <= 0">
                    <!--  -->
                    <span class="w-full flex justify-center text-center py-20 border-gray-300 text-base">
                      <!--  -->
                      <p class="font-semibold flex text-orange-500 whitespace-no-wrap">
                        <!--  -->
                        <span class="">No TeleConsultant selected </span>
                        <!--  -->
                      </p>
                      <!--  -->
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="w-full">
                    <!--  -->
                    <div class="flex flex-col items-center relative">
                      <!--  -->
                      <div
                        class="absolute my-2 bg-white top-100 z-40 w-full lef-0 rounded min-h-select overflow-y-auto svelte-5uyqqj">
                        <!--  -->
                        <div v-for="(user, index) in formData.teleConsultants" :key="index" :value="user._id"
                          class="flex flex-col w-full">
                          <!--  -->
                          <div
                            class="cursor-pointer bg-gray-100 dark:bg-dark-1 border-b border-gray-300 dark:border-dark-1 w-full rounded-t hover:bg-teal-100">
                            <!--  -->
                            <div class="flex w-full items-center p-2 pl-2 relative hover:border-teal-100">
                              <!--  -->
                              <div class="w-6 flex flex-col items-center">
                                <!--  -->
                                <div
                                  class="flex relative w-5 h-5 0 justify-center items-center m-1 mr-2 mt-1 rounded-full">
                                  <!--  -->
                                  <div class="w-6 flex flex-col items-center">
                                    <!--  -->
                                    <div class="flex relative w-5 h-5 justify-center items-center m-1 mr-2">
                                      <!--  -->
                                      <i class="material-icons mx-2">account_circle</i>
                                      <!--  -->
                                    </div>
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->

                              <!--  -->
                              <div class="w-full items-center flex">
                                <!--  -->
                                <div class="mx-2 -mt-1">
                                  <!--  -->
                                  {{ user.fullName }}
                                  <!--  -->
                                  <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                                    <!--  -->
                                    {{ user.email }}
                                    <!--  -->
                                  </div>
                                  <!--  -->
                                </div>
                                <!--  -->
                              </div>
                              <!--  -->

                              <!--  -->
                              <div class="w-6 flex flex-col items-center">
                                <!--  -->
                                <button class="cursor-pointer w-6 h-6 text-black-500 outline-none focus:outline-none"
                                  @click="deleteItem('teleConsultants', index)">
                                  <!--  -->
                                  <i class="material-icons">delete</i>
                                  <!--  -->
                                </button>
                                <!--  -->
                              </div>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="formData._id && (formData.type == 'Seller' || formData.type == 'Courier')">
            <!--  -->
            <div class="flex flex-col">
              <!--  -->
              <div v-if="formData.type == 'Seller'" class="flex mt-10 mb-5 items-center text-center">
                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->

                <!--  -->
                <label @click="toggleVisibility('showFees');"
                  class="block font-medium text-base cursor-pointer text-primary-500 w-full">
                  <!--  -->
                  <span class="font-medium text-base text-primary-800 dark:text-primary-200">
                    {{ $t('fees_seller') }}
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="block">
                    <!--  -->
                    <i class="material-icons" style="transition: 0.3s"
                      :style="showFees ? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i>
                    <!--  -->
                  </span>
                  <!--  -->
                </label>
                <!--  -->

                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div v-if="showFees && formData.type == 'Seller'" class="flex flex-wrap">
                <!--  -->
                <div class="w-full lg:w-1/3 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('confirmation_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.confirmation" min="0" :disabled="!activeAllFees"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/3 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="fulfillement_fees">{{ $t('fulfillement_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.fulfillement_fees" min="0" :disabled="!activeAllFees"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/3 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('upsell_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.upsell_fees" :disabled="!activeAllFees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/4 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('return_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.refund" :disabled="!activeAllFees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/4 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('cancelation_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.cancelation" :disabled="!activeAllFees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/4 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('quality_control') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.quality_control" :disabled="!activeAllFees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/4 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('tva') }}
                          <!--  -->
                          <sup>(%)</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.tva" :disabled="!activeAllFees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/3 Note px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('shipping_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.shipping" :disabled="!activeAllFees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full">
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/3 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('is_confirmed_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" v-model="fees.is_confirmed_fees" min="0"
                        class="py-2 text-xs px-2 outline-none block h-full w-full" />
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div class="w-full lg:w-1/3 px-4 mb-4">
                  <!--  -->
                  <div
                    class="border focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label class="bg-white text-gray-700 px-1" for="grid-password">{{ $t('global_fees') }}
                          <!--  -->
                          <sup v-if="idWharhouse">({{ idWharhouse.currency }})</sup>
                          <!--  -->
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p>
                      <!--  -->
                      <input type="number" min="0" v-model="fees.global_fees" @input="onGlobalFeesChange"
                        class="py-2 text-xs px-2 outline-none block h-full w-full">
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col">
              <!--  -->
              <div class="flex mt-10 mb-5 items-center text-center">
                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->

                <!--  -->
                <label @click="toggleVisibility('showConfig');"
                  class="block font-medium text-base cursor-pointer text-primary-500 w-full">
                  <!--  -->
                  <span class="font-medium text-base text-primary-800 dark:text-primary-200">
                    {{ $t('shipping_configuration') }}
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="block">
                    <!--  -->
                    <i class="material-icons" style="transition: 0.3s"
                      :style="showConfig ? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i>
                    <!--  -->
                  </span>
                  <!--  -->
                </label>
                <!--  -->

                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div v-if="showConfig" class="flex gap-5 flex-wrap">
                <!--  -->
                <div v-if="formData._id && (formData.type == 'Seller' || formData.type == 'Courier')"
                  class="border flex-grow border-orange-700 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="rib" class="bg-white text-gray-700 px-1">{{ $t('city') }} *</label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <p>
                    <!--  -->
                    <input autocomplete="false" tabindex="0" type="text" v-model="formData.city"
                      class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-if="formData._id && (formData.type == 'Seller' || formData.type == 'Courier')"
                  class="border flex-grow border-orange-700 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="rib" class="bg-white text-gray-700 px-1">{{ $t('Adresse de ramassage') }} *</label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <p>
                    <!--  -->
                    <input autocomplete="false" tabindex="0" type="text" v-model="formData.address"
                      class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div v-if="formData._id && (formData.type == 'Seller' || formData.type == 'Courier')"
                  class="border flex-grow  border-orange-700 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="rib" class="bg-white text-gray-700 px-1">{{ $t('Postal Code') }} *</label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <p>
                    <!--  -->
                    <input autocomplete="false" tabindex="0" type="text" v-model="formData.PostalCode"
                      class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div
                  v-if="$f.getAccess(currentUser.role.permissions, 'users', 'create') && formData.type && formData.type == 'Seller'"
                  class=" flex-grow border seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="Countries" class="bg-white text-gray-700 px-1">
                        {{ $t('Aramex Service Code') }}
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <p>
                    <!--  -->
                    <v-select v-model="formData.service_code" :options="service_codes"></v-select>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col">
              <!--  -->
              <div class="flex mt-10 mb-5 items-center text-center">
                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->

                <!--  -->
                <label @click="toggleVisibility('showServices');"
                  class="block font-medium text-base cursor-pointer text-primary-500 w-full">
                  <!--  -->
                  <span class="font-medium text-base text-primary-800 dark:text-primary-200">
                    {{ $t('services') }}
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="block">
                    <!--  -->
                    <i class="material-icons" style="transition: 0.3s"
                      :style="showServices ? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i>
                    <!--  -->
                  </span>
                  <!--  -->
                </label>

                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div v-if="showServices" class="flex flex-col lg:flex-row gap-5">
                <!--  -->
                <div id="confirmation" :class="{ active: settings.confirmation }"
                  class="intro-y flex-1 box-1 py-2 cursor-pointer zoom-in ">
                  <!--  -->
                  <div @click.self="activate('confirmation')">
                    <!--  -->
                    <div class="check">
                      <!--  -->
                      <span class="feather-icon select-none relative">
                        <!--  -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow">
                          <!--  -->
                          <polyline points="20 6 9 17 4 12"></polyline>
                          <!--  -->
                        </svg>
                        <!--  -->
                      </span>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <img
                      src="https://img.icons8.com/external-outline-lafs/64/000000/external-ic_support-menu-outline-lafs.png"
                      class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto" />
                    <!--  -->

                    <!--  -->
                    <div class="text-xl font-medium text-center mt-5">
                      Confirmation
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="px-2" v-if="settings.confirmation && formData.type && formData.type == 'Seller'">
                    <!--  -->
                    <div class="flex items-center mb-4 gap-1">
                      <!--  -->
                      <input v-model="formData.shippingSettings.defaultShipper.autoConfirm.state" type="checkbox"
                        class="-mb-1 h-6 w-6 text-orange-600" id="auto-confirmation" />
                      <!--  -->

                      <!--  -->
                      <label class="font-bold select-none cursor-pointer" for="auto-confirmation">Auto
                        Confirmation
                      </label>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <v-select v-if="!formData.shippingSettings.defaultShipper.autoConfirm.state"
                      class="bg-white font-bold" v-model="formData.shippingSettings.defaultShipper.confirming"
                      :options="this.callCenterAgents" label="name"></v-select>
                    <!--  -->

                    <!--  -->
                    <v-select v-else multiple class="bg-white font-bold"
                      v-model="formData.shippingSettings.defaultShipper.autoConfirm.cities" :options="this.cities"
                      label="name"></v-select>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div id="fulfillement" :class="{ active: settings.fulfillement }"
                  class="intro-y flex-1 box-1 py-2 cursor-pointer zoom-in ">
                  <!--  -->
                  <div @click.self="activate('fulfillement')">
                    <!--  -->
                    <div class="check">
                      <!--  -->
                      <span class="feather-icon select-none relative">
                        <!--  -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow">
                          <!--  -->
                          <polyline points="20 6 9 17 4 12"></polyline>
                          <!--  -->
                        </svg>
                        <!--  -->
                      </span>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <img
                      src="https://img.icons8.com/external-becris-lineal-becris/64/000000/external-warehouse-business-intelligence-becris-lineal-becris.png"
                      class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto" />
                    <!--  -->

                    <!--  -->
                    <div class="text-xl font-medium text-center mt-5"> Warehouse </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="px-2" v-if="settings.fulfillement && formData.type && formData.type == 'Seller'">
                    <!--  -->
                    <v-select class="bg-white font-bold" v-model="formData.shippingSettings.defaultShipper.warehousing"
                      :options="this.shippers.warehousing" label="name"></v-select>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <div id="shipping" :class="{ active: settings.shipping }"
                  class="intro-y flex-1 box-1 py-2 cursor-pointer zoom-in ">
                  <!--  -->
                  <div @click.self="activate('shipping')">
                    <!--  -->
                    <div class="check">
                      <!--  -->
                      <span class="feather-icon select-none relative">
                        <!--  -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-check w-5 h-5 text-white bg-primary-500 rounded-full shadow">
                          <!--  -->
                          <polyline points="20 6 9 17 4 12"></polyline>
                          <!--  -->
                        </svg>
                        <!--  -->
                      </span>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <img
                      src="https://img.icons8.com/external-bartama-glyph-64-bartama-graphic/64/000000/external-Shipping-e-commerce-glyph-bartama-glyph-64-bartama-graphic.png"
                      class="feather feather-shopping-bag block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto block w-12 h-12 text-theme-1 dark:text-theme-10 mx-auto" />
                    <!--  -->

                    <!--  -->
                    <div class="text-xl font-medium text-center mt-5"> Shipping </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="px-2" v-if="settings.shipping && formData.type && formData.type == 'Seller'">
                    <!--  -->
                    <v-select class="bg-white font-bold" v-model="formData.shippingSettings.defaultShipper.shipping"
                      :options="this.shippers.shipping" label="name"></v-select>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="flex flex-col">
              <!--  -->
              <div class="flex mt-10 mb-5 items-center text-center">
                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->

                <!--  -->
                <label @click="toggleVisibility('showGroups');"
                  class="block font-medium text-base cursor-pointer text-primary-500 w-full">
                  <!--  -->
                  <span class="font-medium text-base text-primary-800 dark:text-primary-200">
                    {{ $t('groups') }}
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="block">
                    <!--  -->
                    <i class="material-icons" style="transition: 0.3s"
                      :style="showGroups ? 'transform: rotate(180deg)' : ''">keyboard_arrow_down</i>
                    <!--  -->
                  </span>
                  <!--  -->
                </label>
                <!--  -->

                <!--  -->
                <hr class="border-gray-300 border-1 w-full rounded-md" />
                <!--  -->
              </div>
              <!--  -->

              <!--  v-if="showGroups" -->
              <!--  -->
              <div class="w-full overflow-x-auto border border-gray-300 rounded-lg">
                <!--  -->
                <table v-if="formData.groups" class="min-w-full leading-normal">
                  <!--  -->
                  <thead>
                    <!--  -->
                    <tr class="border-b border-gray-300">
                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('full_name') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('username') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('phone') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('email') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('status') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('role') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-300 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('actions') }}
                      </th>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </thead>
                  <!--  -->

                  <!--  -->
                  <tr class="border-b border-gray-300" v-for="(group, index) in formData.groups" :key="index">
                    <!--  -->
                    <td class="p-2">
                      <!--  -->
                      <input id="fullName" autocomplete="false" tabindex="0" type="text" v-model="group.fullName"
                        placeholder="full name"
                        class="border border-primary-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg overflow-hidden" />
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="p-2">
                      <!--  -->
                      <input id="username" autocomplete="false" tabindex="0" type="text" v-model="group.username"
                        placeholder="user name" @keydown.space="event => event.preventDefault()"
                        class="border border-primary-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg overflow-hidden" />
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="p-2">
                      <!--  -->
                      <input id="phone" autocomplete="false" tabindex="0" type="text" v-model="group.phone"
                        placeholder="phone"
                        class="border border-primary-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg overflow-hidden" />
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="p-2">
                      <!--  -->
                      <input id="email" autocomplete="false" tabindex="0" type="email" v-model="group.email"
                        placeholder="email"
                        class="border border-primary-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg overflow-hidden" />
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="p-2">
                      <!--  -->
                      <select id="type" name="status" autocomplete="type" v-model="group.status"
                        class="border border-primary-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg">
                        <!--  -->
                        <option selected disabled :value="null">Status</option>
                        <!--  -->
                        <option v-for="(value, index) in statusUser" :key="index" :value="value">
                          {{ value }}
                        </option>
                        <!--  -->
                      </select>
                      <!--  -->
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="p-2">
                      <v-select label="name" @input="onChangeRole(group.role)" v-model="group.role" :options="roles"
                        class="border border-primary-600 py-0.5 text-xs px-2 outline-none block h-full w-full rounded-lg"></v-select>
                    </td>
                    <!--  -->

                    <!--  -->
                    <td class="p-2">
                      <!--  -->
                      <div class="flex items-center justify-center gap-2">
                        <!--  -->
                        <div
                          class="w-8 h-8 flex items-center justify-center bg-primary-600 text-white border border-primary-600 cursor-pointer rounded-full hover:bg-transparent hover:text-primary-600 transition-all duration-300"
                          @click="groupsActions('remove', index)">
                          <!--  -->
                          <svg class="w-5 h-5 flex items-center justify-center" aria-hidden="true" focusable="false"
                            data-prefix="fas" data-icon="times" xmlns="http://www.w3.org/2000/svg" width="20px"
                            height="20px" viewBox="0 0 24 24" role="img" fill="none">
                            <!--  -->
                            <path
                              d="M20.1498 7.93997L8.27978 19.81C7.21978 20.88 4.04977 21.3699 3.32977 20.6599C2.60977 19.9499 3.11978 16.78 4.17978 15.71L16.0498 3.84C16.5979 3.31801 17.3283 3.03097 18.0851 3.04019C18.842 3.04942 19.5652 3.35418 20.1004 3.88938C20.6356 4.42457 20.9403 5.14781 20.9496 5.90463C20.9588 6.66146 20.6718 7.39189 20.1498 7.93997V7.93997Z"
                              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <!--  -->
                          </svg>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div
                          class="w-8 h-8 flex items-center justify-center bg-primary-600 text-white border border-primary-600 cursor-pointer rounded-full hover:bg-transparent hover:text-primary-600 transition-all duration-300"
                          @click="groupsActions('remove', index)">
                          <!--  -->
                          <svg class="w-5 h-5 flex items-center justify-center" aria-hidden="true" focusable="false"
                            data-prefix="fas" data-icon="times" xmlns="http://www.w3.org/2000/svg" width="20px"
                            height="20px" viewBox="0 0 24 24" role="img" fill="none">
                            <!--  -->
                            <path
                              d="M9.87787 4.24993C10.1871 3.37503 11.0215 2.75 12 2.75C12.9785 2.75 13.813 3.37503 14.1222 4.24993C14.2602 4.64047 14.6887 4.84517 15.0793 4.70713C15.4698 4.56909 15.6745 4.1406 15.5365 3.75007C15.022 2.29459 13.634 1.25 12 1.25C10.3661 1.25 8.97804 2.29459 8.46361 3.75007C8.32557 4.1406 8.53026 4.56909 8.9208 4.70713C9.31134 4.84517 9.73983 4.64047 9.87787 4.24993Z"
                              fill="currentColor" />
                            <!--  -->
                            <path
                              d="M2.75 6C2.75 5.58579 3.08579 5.25 3.5 5.25H20.5001C20.9143 5.25 21.2501 5.58579 21.2501 6C21.2501 6.41421 20.9143 6.75 20.5001 6.75H3.5C3.08579 6.75 2.75 6.41421 2.75 6Z"
                              fill="currentColor" />
                            <!--  -->
                            <path
                              d="M5.11686 7.75166C5.53015 7.72411 5.88753 8.03681 5.91508 8.45011L6.37503 15.3492C6.46488 16.6971 6.52891 17.6349 6.66948 18.3405C6.80583 19.025 6.99616 19.3873 7.26957 19.6431C7.54299 19.8988 7.91715 20.0647 8.60915 20.1552C9.32255 20.2485 10.2626 20.25 11.6134 20.25H12.3868C13.7376 20.25 14.6776 20.2485 15.391 20.1552C16.083 20.0647 16.4572 19.8988 16.7306 19.6431C17.004 19.3873 17.1943 19.025 17.3307 18.3405C17.4712 17.6349 17.5353 16.6971 17.6251 15.3492L18.0851 8.45011C18.1126 8.03681 18.47 7.72411 18.8833 7.75166C19.2966 7.77921 19.6093 8.13659 19.5818 8.54989L19.1183 15.5016C19.0328 16.7844 18.9637 17.8205 18.8018 18.6336C18.6334 19.4789 18.347 20.185 17.7554 20.7384C17.1638 21.2919 16.4402 21.5307 15.5856 21.6425C14.7635 21.75 13.7251 21.75 12.4395 21.75H11.5607C10.2751 21.75 9.23663 21.75 8.41459 21.6425C7.55994 21.5307 6.83639 21.2919 6.2448 20.7384C5.6532 20.185 5.36678 19.4789 5.19838 18.6336C5.03641 17.8205 4.96735 16.7844 4.88186 15.5016L4.41841 8.54989C4.39085 8.13659 4.70356 7.77921 5.11686 7.75166Z"
                              fill="currentColor" />
                            <!--  -->
                          </svg>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </td>
                    <!--  -->
                  </tr>
                  <!--  -->
                </table>
                <!--  -->

                <!--  -->
                <div class="bg-indigo-100 flex justify-center items-center gap-2 p-2">
                  <!--  -->
                  <div
                    class="w-fit h-9 flex gap-2 items-center justify-center text-primary-600 border border-primary-600 cursor-pointer rounded-full px-4 hover:bg-primary-600 hover:text-white transition-all duration-300"
                    @click="CreateNewRole">
                    <!--  -->
                    <svg class="w-5 h-5 flex items-center justify-center" xmlns="http://www.w3.org/2000/svg"
                      width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                      <!--  -->
                      <path
                        d="M14.1625 18.4876L13.4417 19.2084C11.053 21.5971 7.18019 21.5971 4.79151 19.2084C2.40283 16.8198 2.40283 12.9469 4.79151 10.5583L5.51236 9.8374"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                      <!--  -->

                      <!--  -->
                      <path d="M9.8374 14.1625L14.1625 9.8374" stroke="currentColor" stroke-width="1.5"
                        stroke-linecap="round" />
                      <!--  -->

                      <!--  -->
                      <path
                        d="M9.8374 5.51236L10.5583 4.79151C12.9469 2.40283 16.8198 2.40283 19.2084 4.79151C21.5971 7.18019 21.5971 11.053 19.2084 13.4417L18.4876 14.1625"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                      <!--  -->
                    </svg>
                    <!--  -->

                    <!--  -->
                    <span class="text-sm "> {{ $t('create_new_role') }} </span>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div
                    class="w-fit h-9 flex gap-2 items-center justify-center bg-primary-600 text-white border border-primary-600 cursor-pointer rounded-full px-4 hover:bg-transparent hover:text-primary-600 transition-all duration-300"
                    @click="groupsActions('add')">
                    <!--  -->
                    <svg class="w-5 h-5 flex items-center justify-center" aria-hidden="true" focusable="false"
                      data-prefix="fas" data-icon="plus" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                      viewBox="0 0 24 24" fill="none">
                      <!--  -->
                      <path d="M6 12H18M12 6V18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <!--  -->
                    </svg>
                    <!--  -->

                    <!--  -->
                    <span class="text-sm "> {{ $t('add_user') }} </span>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="mt-20 pt-3 pb-4 flex justify-center">
            <!--  -->
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              @click="save">
              {{ $t('save') }}
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  data() {
    return {
      cities: [],
      callCenterAgents: [],
      shippers: {
        shipping: [],
        warehousing: [],
        confirming: [],
      },
      formData: {
        shippingSettings: {
          closingTime: null,
          lastPickupTime: null,
          pickupDate: null,
          readyTime: null,
          defaultShipper: {
            autoConfirm: {
              state: false,
              cities: [],
            },
            confirming: {
              id: null,
              name: null,
            },
            warehousing: {
              id: null,
              name: null,
            },
            shipping: {
              id: null,
              name: null,
            },
          },
        },
        category: null,
        role: null,
        zones: [],
        countries: [],
        fees: {},
        settings: {},
        type: '',
        source: '',
        service_code: 'CODS',
        teleConsultants: [],
        groups: [],
      },
      apiShipping: {
        client_id: null,
        client_secret: null,
      },
      isHidden: false,
      roles: [],
      zones: [],
      company: null,
      selectContries: [],
      currentZone: [],
      allZones: [],
      types: [
        'Seller',
        'TeleConsultant',
        'StockManager',
        'Courier',
        'Accountant',
        'Admin',
      ],
      categories: [],
      warehouses: [],
      options: this.$countries,
      livreur: '',
      selectedRole: '',
      roleformdata: '',
      tempZones: [],
      checkbox: true,
      loading: false,
      fullPage: false,
      currency: '',
      idWharhouse: null,
      currentUser: {
        role: {},
      },
      fees: {
        confirmation: -1,
        fulfillement_fees: -1,
        global_fees: -1,
        shipping: -1,
        shippingzones: [],
        refund: -1,
        change: -1,
        quality_control: -1,
        tva: -1,
      },
      settings: {
        open_colis: false,
        confirmation: false,
        fulfillement: false,
        shipping: false,
      },
      sources: [
        'EDCO',
        'SHIPSEN',
        'STOREINO',
        'LEADVERTEX',
        'CHRONODIALI',
        'ARAMEX',
        'SHOPIFY',
        'BRIDGE',
      ],
      statusUser: ['active', 'inactive', 'blocked', 'deleted'],
      service_codes: ['CODS', 'FIRST', 'FRDM', 'HFPU', 'NOON', 'SIG'],
      arrIndex: {},
      colors: '#194d33',
      agents: [],
      searchTextTeleConsultant: '',
      activeAllFees: true,
      showFees: false,
      showConfig: false,
      showServices: false,
      showGroups: false,
    };
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {
      await this.getwharhouseId();
      await this.dataToEdit();
    },
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  async mounted() {
    await this.getCities(await this.warhouseSelected);
    await this.getUser();
    await this.getwharhouseId();

    await this.getCategories();
    await this.getRoles();
    await this.dataToEdit();

    await this.getRoleByType();
    await this.getWarehouses();
    this.getDtaStorage();

    if (this.formData._id) {
      this.formData.role = this.roleformdata;
    }

    await this.getCouriers();
    this.onGlobalFeesChange();
  },
  methods: {
    groupsActions(action, index) {
      if (action === 'remove') {
        this.formData.groups.splice(index, 1);
      } else {
        this.formData.groups.push(
          {
            countries: ['MA'],
            fullName: '',
            username: '',
            phone: '',
            email: '',
            role: null,
            type: 'SubSeller',
            active: ''
          }
        )
      }
    },
    toggleVisibility(field) {
      this[field] = !this[field];
    },
    onGlobalFeesChange() {
      const globalFeesValue = parseFloat(this.fees.global_fees);

      if (globalFeesValue == -1) {
        this.activeAllFees = true;
      } else if (!isNaN(globalFeesValue) && globalFeesValue > -1) {
        this.activeAllFees = false;
      }
    },
    async getCities(country) {
      const resCities = await this.$server.get('zones', {
        allCities: true,
        country: country,
      });

      if (resCities.content.length > 0) this.cities = resCities.content;
      else this.cities = [];
    },
    groupDocumentsByWarehouse(documents) {
      const grouped = {};

      documents.forEach(doc => {
        if (doc.type.toUpperCase() === 'COURIER') {
          doc.settings.forEach(setting => {
            const warehouseId = setting.warehouse;

            if (warehouseId) {
              if (!grouped[warehouseId]) {
                grouped[warehouseId] = {
                  confirming: [],
                  shipping: [],
                  warehousing: [],
                };
              }

              const settings = setting;
              const courier = { id: doc._id, name: doc.fullName };

              if (settings.confirmation) {
                grouped[warehouseId].confirming.push(courier);
              }

              if (settings.shipping) {
                grouped[warehouseId].shipping.push(courier);
              }

              if (settings.fulfillement) {
                grouped[warehouseId].warehousing.push(courier);
              }
            }
          });
        } else {
          doc.countries.forEach(country => {
            if (!grouped[country]) {
              grouped[country] = [];
            }

            const callCenterAgent = { id: doc._id, name: doc.fullName };
            grouped[country].push(callCenterAgent);
          });
        }
      });

      return grouped;
    },
    async getCouriers() {
      const filters = {
        role: '600d6ff3fefb68079831e088',
      };

      filters['countries'] = await this.warhouseSelected;
      const res = await this.$server.search('users', filters);
      const callCenterAgentsResponse = await this.$server.search('users', {
        role: '601535dbbfadcc2e48d83e19',
      });

      if (
        res.content &&
        res.content.results.length > 0 &&
        callCenterAgentsResponse.content &&
        callCenterAgentsResponse.content.results.length > 0
      ) {
        const groupedCouriers = this.groupDocumentsByWarehouse(
          res.content.results,
        );
        const groupedAgents = this.groupDocumentsByWarehouse(
          callCenterAgentsResponse.content.results,
        );

        this.shippers = groupedCouriers[this.idWharhouse._id];
        this.callCenterAgents = [
          ...groupedAgents[this.idWharhouse.country],
          ...this.shippers.confirming,
        ];
      } else {
        this.shippers = {
          confirming: [],
          shipping: [],
          warehousing: [],
        };
      }
    },
    RouterBack: function () {
      this.$router.back();
    },
    setSource(source) {
      if (source) {
        if (source == 'ARAMEX')
          this.apiShipping = {
            UserName: 'testingapi@aramex.com',
            Password: 'R123456789$r',
            AccountNumber: '153893',
            AccountPin: '116216',
            AccountEntity: 'CAS',
            AccountCountryCode: 'MA',
            Version: 'v1',
            color: '#194d33',
            gardien: '#194d33',
          };
        else if (source == 'EDCO' || source == 'SHIPSEN') {
          this.apiShipping = {
            key: null,
            secret: null,
            apiLink: '',
            logoLink: '',
            color: '#194d33',
            gardien: '#194d33',
          };
        } else
          this.apiShipping = {
            client_id: null,
            client_secret: null,
            color: '#194d33',
            gardien: '#194d33',
          };
      }
    },
    activate: function (el) {
      this.settings[el] = !this.settings[el];
    },
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.currency = res;
      });
    },
    async changeData(data, warhouse, element) {
      for (var i in data) {
        if (data[i].warehouse == warhouse.toString()) {
          data[i] = element;
          break;
        }
      }
    },
    async setSelectedCountries(countries) {
      if (countries) {
        this.formData.countries.forEach(
          function (part, index, theArray) {
            if (typeof part === 'object' && part !== null)
              theArray[index] = part.countryName;
          }.bind(this),
        );

        let uniqueChars = this.formData.countries.filter((c, index) => {
          return this.formData.countries.indexOf(c) === index;
        });

        this.formData.countries = uniqueChars;

        if (this.formData.type === 'CallcenterManager') {
          await this.getTeleConsultants();
        }
      }
    },
    async getWarehouses() {
      const filter = { limit: 1000, is_primary: true };
      const res = await this.$server.search('warehouses', filter);
      if (res.content.results) {
        this.warehouses = res.content.results;
      } else this.warehouses = [];
    },
    getDtaStorage() {
      if (
        localStorage.getItem('Role') != null &&
        localStorage.getItem('User_email') != null
      ) {
        let Role = JSON.parse(localStorage.getItem('Role'));
        this.formData.email = localStorage.getItem('User_email');
        this.selectedRole = Role;
        this.formData.role = Role;
        this.formData.type = Role.type;
        if (localStorage.getItem('User_username') != null)
          this.formData.username = localStorage.getItem('User_username');
        if (localStorage.getItem('User_fullName') != null)
          this.formData.fullName = localStorage.getItem('User_fullName');
      }
    },
    DeleteDtaStorage() {
      localStorage.removeItem('Role');
      localStorage.removeItem('User_email');
      localStorage.removeItem('User_username');
      localStorage.removeItem('User_fullName');
    },
    searchRoles: _.debounce(async function (search) {
      const filter = {
        limit: this.limit,
        name: search,
      };
      const res = await this.$server.find('roles', filter);

      if (res.content.results) {
        this.roles = res.content.results;
      } else {
        this.roles = [];
      }
    }, 500),
    CreateNewRole() {
      localStorage.setItem('User_email', this.formData.email);
      localStorage.setItem('User_username', this.formData.username);
      localStorage.setItem('User_fullName', this.formData.fullName);
      this.$router.push('/roles/new');
    },
    async save() {
      if (this.formData._id) {
        this.ConvertArrayToCountyCode(this.formData.countries);
        this.formData.email = this.formData.email.toLowerCase().trim();

        if (this.formData.type == 'Seller' || this.formData.type == 'Courier') {
          let dataWahrhouse = null,
            dataWahrhouseSetting = null;

          if (this.formData.type == 'Seller') {
            dataWahrhouse = await this.$server.get('users', {
              id: this.$route.params.id,
              warehouse: this.idWharhouse._id,
            });
          }

          dataWahrhouseSetting = await this.$server.get('users', {
            id: this.$route.params.id,
            warehouseSettings: this.idWharhouse._id,
          });

          if (dataWahrhouse && dataWahrhouse.content.length > 0) {
            this.changeData(
              this.formData.fees,
              this.idWharhouse._id,
              this.fees,
            );
          } else {
            this.fees.warehouse = await this.idWharhouse._id;
            this.formData.fees.push(this.fees);
          }

          if (dataWahrhouseSetting && dataWahrhouseSetting.content.length > 0) {
            this.changeData(
              this.formData.settings,
              this.idWharhouse._id,
              this.settings,
            );
          } else {
            this.settings.warehouse = await this.idWharhouse._id;
            this.formData.settings.push(this.settings);
          }
        }

        if (this.formData.countries.length == 0) {
          alert('Countries required', 'warning');
          return false;
        }

        if (this.formData.type == 'Courier') {
          if (!this.formData.apiShipping) this.formData.apiShipping = {};
          this.formData.apiShipping = this.apiShipping;
        }

        if (this.formData.shippingSettings.defaultShipper.autoConfirm.state) {
          this.formData.shippingSettings.defaultShipper.confirming = null;
        }

        const data = await this.$server.update('users', this.formData);

        if (data && data._id) alert(this.$t('user_updated'), 'success');
        else alert(data, 'warning');
      } else {
        if (this.formData.role == null && this.formData.type == '') {
          alert(this.$t('role_required'), 'warning');
        } else {
          if (
            localStorage.getItem('Role_id') === null &&
            localStorage.getItem('User_email') === null
          ) {
            this.formData.type = this.formData.role.type;
          }

          if (this.checkData()) {
            if (this.formData.username.length < 3) {
              alert(this.$t('username_not_valid'), 'warning');
              return false;
            }

            this.formData.email = this.formData.email.toLowerCase().trim();
            const checkUser = await this.$server.find('users', {
              name: this.formData.email,
            });

            if (checkUser.content.results.length > 0) {
              alert(this.$t('email_exist'), 'warning');
              return false;
            }

            this.ConvertArrayToCountyCode(this.formData.countries);
            delete this.formData.fees;
            delete this.formData.settings;

            if (this.formData.type == 'Courier') {
              if (!this.formData.apiShipping) this.formData.apiShipping = {};
              this.formData.apiShipping = this.apiShipping;
            }

            if (
              this.formData.shippingSettings.defaultShipper.autoConfirm.state
            ) {
              this.formData.shippingSettings.defaultShipper.confirming = null;
            }

            const data = await this.$server.create('users', this.formData);

            if (data.content._id) {
              alert(this.$t('user_created'), 'success');
              this.DeleteDtaStorage();
              this.selectContries = [];
              this.agents = [];
              this.formData = {
                teleConsultants: [],
                zones: [],
                countries: [],
                type: '',
                source: '',
              };
              for (let i = 0; i < this.zones.length; i++) {
                this.zones[i].check = '';
              }
            }
          } else {
            alert(this.$t('all_required_field'), 'warning');
          }
        }
      }
    },
    getRowDetail(zone_id) {
      let itemInRow = this.formData.zones.filter(item => item === zone_id);
      let isItemInRow = itemInRow.length > 0;

      if (isItemInRow) {
        let pos = this.formData.zones
          .map(function (e) {
            return e;
          })
          .indexOf(zone_id);
        this.formData.zones.splice(pos, 1);
      } else {
        this.formData.zones.push(zone_id);
      }
    },
    checkData() {
      if (
        this.formData.countries.length > 0 &&
        this.formData.role &&
        this.formData.email &&
        this.formData.type &&
        this.formData.username &&
        this.formData.fullName
      )
        return true;
      else return false;
    },
    async getRoleByType() {
      const filter = {
        type: 'Courier',
      };
      const res = await this.$server.get('roles', filter);
      this.livreur = res.content._id;
    },
    async onChangeRole(data) {
      if (data && data._id && !this.formData._id) {
        this.formData.type = data.type || '';
        this.selectedRole = data._id;
      }

      if (data.type === 'CallcenterManager') {
        await this.getTeleConsultants();
      } else {
        this.agents = [];
        this.formData.teleConsultants = [];
      }
    },
    addZones(item) {
      if (item.check) {
        const zone = {
          _id: item._id,
        };
        this.tempZones.push(zone);
      } else {
        let pos = this.tempZones
          .map(function (e) {
            return e._id;
          })
          .indexOf(item._id);
        this.tempZones.splice(pos, 1);
      }
    },
    async getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse && o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        this.loading = true;

        const editData = await this.$server.get('users', {
          id: this.$route.params.id,
        });

        this.loading = false;
        const dataWahrhouse = await this.$server.get('users', {
          id: this.$route.params.id,
          warehouse: this.idWharhouse._id,
        });

        const dataWahrhouseSetting = await this.$server.get('users', {
          id: this.$route.params.id,
          warehouseSettings: this.idWharhouse._id,
        });

        if (dataWahrhouse.content.length > 0) {
          this.fees = await this.getElementInArray(
            dataWahrhouse.content[0].fees,
            this.idWharhouse._id,
          );

          if (!this.fees.shippingzones) {
            this.fees.shippingzones = [];
          }
        } else {
          this.fees = {
            confirmation: -1,
            fulfillement_fees: -1,
            global_fees: -1,
            shipping: -1,
            shippingzones: [],
            refund: -1,
            change: -1,
            quality_control: -1,
            tva: -1,
          };
        }

        if (this.idWharhouse && this.idWharhouse.country) {
          this.zones.forEach(
            function (zone, i) {
              this.addOrReplace({
                name: zone.name,
                zone: zone._id,
                price: zone.price,
              });
            }.bind(this),
          );
        }

        if (dataWahrhouseSetting.content.length > 0) {
          this.settings = await this.getElementInArray(
            dataWahrhouseSetting.content[0].settings,
            this.idWharhouse._id,
          );
        } else {
          this.settings = {
            open_colis: false,
            confirmation: false,
            fulfillement: false,
            shipping: false,
          };
        }

        this.formData = editData.content;

        if (
          this.formData.type == 'Courier' ||
          (this.formData.type == 'Seller' &&
            this.formData.source == 'CHRONODIALI')
        ) {
          if (this.formData.apiShipping) {
            this.apiShipping = this.formData.apiShipping;
          }
        }

        if (editData.content.company) this.company = editData.content.company;

        // this.formData.role=this.formData.role._id;
        this.roleformdata = this.formData.role;

        //this.selectContries=this.formData.countries;
        this.ConvertArrayToCountyName(this.formData.countries);

        // this.formData.category = this.formData.categories[0];
        this.selectedRole = this.formData.role._id;
        this.currentZone = this.formData.zones;

        for (let j = 0; j < this.currentZone.length; j++) {
          for (let i = 0; i < this.allZones.length; i++) {
            if (this.zones[i]._id == this.currentZone[j]) {
              this.zones[i].check = this.zones[i]._id;
            }
          }
        }

        if (this.formData.type === 'CallcenterManager') {
          await this.getTeleConsultants();
        }
      }
    },
    ConvertArrayToCountyName(data) {
      data.forEach(
        function (part, index, theArray) {
          var count = part.length;
          if (count == 2)
            theArray[index] = this.$f.getCountryNameByCode(this.options, part);
        }.bind(this),
      );
    },
    addOrReplace(obj) {
      const index = this.fees.shippingzones.findIndex(
        e => e.zone.toString() === obj.zone.toString(),
      );
      if (index === -1) this.fees.shippingzones.push(obj);
    },
    ConvertArrayToCountyCode(data) {
      data.forEach(
        function (part, index, theArray) {
          var count = part.length;
          if (count > 2)
            theArray[index] = this.$f.getCountryCodeByName(this.options, part);
        }.bind(this),
      );
    },
    async getCategories() {
      const res = await this.$server.search('categories');
      if (res.content.results) this.categories = res.content.results;
      else this.categories = [];
    },
    async getRoles() {
      const res = await this.$server.search('roles', { limit: 1000 });
      if (res.content.results) this.roles = res.content.results;
      else this.roles = [];
    },
    async getZones() {
      const res = await this.$server.search('zones', {
        limit: 1000,
        country: await this.warhouseSelected,
      });

      if (res.content.results) {
        this.zones = res.content.results;

        for (let i = 0; i < this.zones.length; i++) {
          this.allZones.push(this.zones[i]._id);
        }
      } else {
        this.zones = this.allZones = [];
      }
    },
    async addItem(index) {
      try {
        const item = this.agents[index];
        const itemList = this.formData.teleConsultants;

        const existingIndex = itemList.findIndex(o => o._id === item._id);

        if (existingIndex !== -1) {
          alert(`This teleConsultant already exists in the group`, 'warning');
          return;
        }

        itemList.push(item);
      } catch (error) {
        console.error(`Error adding item to teleConsultants:`, error);
      }
    },
    async deleteItem(index) {
      try {
        this.formData.teleConsultants.splice(index, 1);
      } catch (error) {
        console.error(`Error deleting item from teleconsultant:`, error);
      }
    },
    async getTeleConsultants() {
      if (this.formData.countries.length > 0) {
        try {
          const country = this.$f.getCountryCodeByName(
            this.options,
            this.formData.countries[0],
          );

          const res = await this.$server.search('users', {
            type: 'TeleConsultant',
            countries: country,
            limit: 10,
          });

          if (res.content.results) {
            this.agents = res.content.results;
          } else {
            this.agents = [];
          }
        } catch (error) {
          console.error(`Error search item from teleconsultant:`, error);
        }
      }
    },
    searchTeleConsultants: _.debounce(async function (search) {
      if (this.formData.countries.length > 0) {
        try {
          const country = this.$f.getCountryCodeByName(
            this.options,
            this.formData.countries[0],
          );

          const filter = {
            type: 'TeleConsultant',
            limit: this.limit,
            countries: country,
            name: search.target.value,
          };

          const res = await this.$server.find('users', filter);
          const results = res.content.results || [];

          this.agents = results;
        } catch (error) {
          console.error(`Error find item from teleconsultant:`, error);
        }
      }
    }, 500),
  },
};
</script>

<style scoped>
.top-100 {
  top: 100%;
}

.max-h-select {
  max-height: 190px;
}

.min-h-select {
  max-height: 256px;
}

.h-select {
  height: 283px;
}

.vs__dropdown-toggle {
  border: none;
}

.btn-marketing {
  cursor: pointer;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 500;
  box-shadow: 0 0 #0000, 0 0 #0000;
  transition-property: color, background-color, border-color, fill, stroke,
    opacity, box-shadow, transform, filter, -webkit-text-decoration-color,
    -webkit-backdrop-filter;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter;
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
    backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

.btn-marketing.btn-primary {
  border-color: rgb(0 143 188/1);
  background-color: rgb(0 159 209/1);
  color: rgb(255 255 255/1);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.marketing-input {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.marketing-input {
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: rgb(16 21 27/1);
  appearance: none;
  background-color: #fff;
}

.object {
  width: 300px;
  height: 300px;
  margin-left: 80px;
  opacity: 0;
  background: white;
  border-radius: 5%;
  border-color: #d3d3d3;
  border-width: thin;
  transform: scaleY(0.8) skewX(10deg);
  transform-origin: 50% 0%;
  transition-duration: 0.25s;
}

.button:hover+.object {
  opacity: 1;
  transform: scaleY(1) skewX(0deg);
}

.Note table {
  font-family: sans-serif;
}

.Note table th,
.Note table td {
  padding: 0.25em 0.5em;
  text-align: left;
  font-size: 14px;
}

.Note table th:nth-child(2),
.Note table td:nth-child(2) {
  text-align: left;
}

.Note table td {
  background-color: #eee;
}

.Note table th {
  background-color: #137212;
  color: #fff;
  position: sticky;
  top: 0;
}

.pane {
  display: inline-block;
  overflow-y: scroll;
  max-height: 200px;
  width: 100%;
  margin-top: 8px;
}

.zigzag {
  border-collapse: separate;
  border-spacing: 0.25em 9px;
  width: 100%;
}

.button_blink {
  animation: shadow-pulse 1s infinite;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(30, 112, 185);
  }

  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}
</style>
